import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getTermsAndConditions, updateTermsAndCondition } from '../../../utils/urls';
import TextEditor from '../../../components/TextEditor';
import CustomButton from '../../../components/common/CustomButton/CustomButton';

const TermsAndConditionConfig = () => {
    const [tcDescription, setTcDescription] = useState('');
    const [tcLoading, setTcLoading] = useState(false);

    useEffect(() => {
        const fetchTermsAndConditions = async () => {
            try {
                const res = await axios.get(getTermsAndConditions);
                const fetchedDescription = res?.data?.data?.config?.content || '';
                setTcDescription(fetchedDescription);
            } catch (error) {
                console.error('Failed to fetch T&C:', error);
                toast.error('Failed to load Terms and Conditions.');
            }
        };
        fetchTermsAndConditions();
    }, []);

    const handleTcSubmit = async (values, { setSubmitting }) => {
        setTcLoading(true);
        try {
            await axios.put(updateTermsAndCondition, {
                content: values.description,
            });
            toast.success('Terms and Conditions updated successfully!');
        } catch (error) {
            console.error('Failed to update T&C:', error);
            toast.error('Failed to update Terms and Conditions.');
        } finally {
            setTcLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={{ description: tcDescription }}
            onSubmit={handleTcSubmit}
            enableReinitialize
        >
            <Form className="border rounded-lg p-6 shadow-sm bg-white">
                <h2 className="text-xl font-semibold text-blue-900 mb-6">Terms & Conditions</h2>
                <div className="grid grid-cols-1">
                    <TextEditor name="description" label="Description" required />
                    <div className="flex justify-end gap-2 mt-4">
                        <CustomButton label="Cancel" variant="outlined" type="button" />
                        <CustomButton
                            label="Save"
                            variant="contained"
                            type="submit"
                            className="bg-blue-500 text-white"
                            isLoading={tcLoading}
                            disabled={tcLoading}
                        />
                    </div>
                </div>
            </Form>
        </Formik>
    );
};

export default TermsAndConditionConfig;
